export const cartStepsPayload = (label: string) => ({
  event: 'analytics-event',
  event_parameters: {
    event_name: 'interaction_carrinho',
    cd_interaction_detail: `click:${label}`,
  },
});
